import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-with-label',
  standalone: true,
  imports: [],
  templateUrl: './text-with-label.component.html',
  styleUrl: './text-with-label.component.scss'
})
export class TextWithLabelComponent {
  @Input() label!: string;
}
